// @flow

// Types
import type {
  User,
  UsersById,
} from 'fc-model-users/types'

// Constants
import {
  PROP_USER_ID,
  PROP_PARENT,
} from 'fc-model-users'

// Utils
import emptyArrayOr from 'fc-utils/emptyArrayOr'
import emptyObjectOr from 'fc-utils/emptyObjectOr'

// Libs
import { createSelector } from 'reselect'
import _filter from 'lodash/filter'
import _keyBy from 'lodash/keyBy'

// Selectors
import { users$ } from 'fc-users'
import { authenticatedUser$ } from 'fc-authenticated-user'

export const heftyUsers$ = createSelector(
  [users$, authenticatedUser$],
  function (users: UsersById, authenticatedUser: User): Array<User> {
    if (!authenticatedUser) {
      return emptyArrayOr()
    }

    const authenticatedUserId = authenticatedUser[PROP_USER_ID]
    const parentId = authenticatedUser[PROP_PARENT]

    const heftyUsers = _filter(users, (user: User): Array<User> => {
      return (
        user[PROP_USER_ID] === authenticatedUserId ||
        user[PROP_PARENT] === authenticatedUserId ||
        user[PROP_USER_ID] === parentId
      )
    })

    return emptyArrayOr(heftyUsers)
  }
)

export const usersById$ = createSelector(
  [heftyUsers$],
  function (users: Array<User>): Array<User> {
    return emptyObjectOr(_keyBy(users, PROP_USER_ID))
  }
)

export default heftyUsers$
